<template>
  <tr>
    <td>{{ item.game_id }}</td>
    <td>{{ item.bet }}</td>
    <td class="user" @click="show">{{ item.user_id }}</td>
    <td>{{ item.orientation }}</td>
    <td>{{ item.chosen_number }}</td>
    <td>{{ item.rate }}</td>
    <td>
      {{ item.factor }}
    </td><td>{{ item.prize }}</td>
    <td>
      {{ item.result }}
    </td><td>{{ item.created_at }}</td>
  </tr>
</template>

<script>
export default {
  name: 'DiceStatiscticsItem',
  props: {
    item: Object
  },
  methods: {
    show () {
      this.$router.push(`/users/${this.item.user_id}`)
    }
  }
}
</script>

<style scoped>
    .user {
        cursor: pointer;
    }

    .user:hover {
        background: #d7d7d7;
    }
</style>
